import { render, staticRenderFns } from "./copyright.vue?vue&type=template&id=696b7b48&scoped=true"
import script from "./copyright.vue?vue&type=script&lang=js"
export * from "./copyright.vue?vue&type=script&lang=js"
import style0 from "./copyright.vue?vue&type=style&index=0&id=696b7b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696b7b48",
  null
  
)

export default component.exports